'use client';
'use strict';

var jsxRuntime = require('react/jsx-runtime');
var tailwindMerge = require('tailwind-merge');
require('../../DataDisplays/Avatar/Avatar.js');
var Typography = require('../../Base/Typography/Typography.js');
var Box = require('../../Base/Layouts/Box/Box.js');
require('../../Base/Layouts/FullBleed/FullBleed.js');
require('../../DataDisplays/Label/Label.js');
var SystemIcon = require('../../DataDisplays/SystemIcon/SystemIcon.js');

/**
 * 삭제 가능한 칩(chip) 형태의 입력 컴포넌트입니다.
 *
 * @component
 * @param {Object} props
 * @param {React.ReactNode} props.children - 칩 내부에 표시될 콘텐츠
 * @param {() => void} [props.onDelete] - 삭제 버튼 클릭 시 실행될 콜백 함수
 * @param {string} [props.className] - 추가적인 CSS 클래스
 *
 * @example
 * ```tsx
 * // 기본 사용
 * <InputChip>태그</InputChip>
 *
 * // 삭제 기능이 있는 칩
 * <InputChip onDelete={() => console.log('삭제됨')}>
 *   삭제 가능한 태그
 * </InputChip>
 *
 * // 커스텀 스타일이 적용된 칩
 * <InputChip className="bg-blue-100">
 *   커스텀 스타일 태그
 * </InputChip>
 * ```
 */ const InputChip = ({ children, onDelete, className })=>{
    return jsxRuntime.jsxs(Box, {
        "data-testid": "design-system-input-chip--container",
        className: tailwindMerge.twMerge('flex h-6 w-fit max-w-[100px] select-none items-center gap-0.5 rounded-lg bg-w-gray-100 px-2 py-px', !!onDelete && 'pl-2 pr-1.5', className),
        children: [
            jsxRuntime.jsx(Typography, {
                variant: "body2",
                className: "h-6 w-full overflow-hidden text-ellipsis whitespace-nowrap break-all text-w-gray-600",
                children: children
            }),
            !!onDelete && jsxRuntime.jsx(Box, {
                onClick: onDelete,
                "data-testid": "design-system-input-chip--delete",
                children: jsxRuntime.jsx(SystemIcon, {
                    name: "small_delete",
                    className: "cursor-pointer text-w-gray-400"
                })
            })
        ]
    });
};

module.exports = InputChip;
